<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="REQUISIÇÃO DE COMPRA" fa-icon="dolly">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/rcms']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="row">
        <div class="col-12">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
                aria-selected="true" (click)="selecionarTab(1)">Dados Requisição</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                aria-selected="false" (click)="selecionarTab(2)">Itens</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="favorecido-tab" data-toggle="tab" href="#favorecido" role="tab"
                aria-controls="favorecido" aria-selected="false" (click)="selecionarTab(3)">Fornecedores</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="cotacao-tab" data-toggle="tab" href="#cotacao" role="tab" aria-controls="cotacao"
                aria-selected="false" (click)="selecionarTab(4)">Cotações</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <br />
              <div *ngIf="entidade.excluido" class="row">
                <div class="col-12">
                  <div class="alert alert-danger">
                    Requisição excluída em <b>{{entidade.data_exclusao | date:'dd/MM/yyyy':'GMT'}}</b>
                    pelo usuário <b>{{entidade.usuario_exclusao?.nome}}</b>
                    com a justificativa: <u>{{entidade.motivo_exclusao}}</u>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-row mt-1">
                        <div class="col-md-4">
                          <br>
                          <table>
                            <td style="font-size: 22px; font-weight: bold; color: #157111; padding-right: 4px;">Nº:</td>
                            <td style="font-size: 22px; font-weight: bold; color: #157111">{{ ("00000" +
                              entidade.numero).slice(-5) }}
                            </td>
                          </table>
                        </div>
                      </div>
                      <div class="form-row mt-2">
                        <div class="col-md-4">
                          <label for="contrato">Contrato</label>
                          <input readonly value="{{entidade?.contrato?.numero | mascarar : '0000/0000'}}" type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                        <div class="col-md-4">
                          <label for="processo">Processo</label>
                          <input readonly [value]="entidade.processo" type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                        <div class="col-md-4">
                          <label for="licitacao">Licitação</label>
                          <input readonly value="{{entidade?.licitacao?.numero | mascarar : '0000/0000'}}" type="text"
                            unmask="true" class="form-control-plaintext form-control text-center">
                        </div>
                      </div>
                      <div class="form-row mt-3">
                        <div class="col-md-4">
                          <label for="data_rcms">Data Requisição</label>
                          <input readonly value="{{entidade.data_rcms | date:'dd/MM/yyyy':'GMT'}}" type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                        <div class="form-group col-sm-8">
                          <label for="requerente">Requerente</label>
                          <input readonly [value]="entidade.requerente?.nome" type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-sm-5">
                          <label for="prioridade">Prioridade</label>
                          <input readonly value="{{globalService.tituloPrioridadeRCMS(entidade.prioridade)}}" type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-row">
                        <div class="col-sm-12">
                          <div class="card">
                            <ul class="list-group list-group-flush">
                              <li
                                class="list-group-item font-weight-bold bg-success d-flex justify-content-between align-items-center text-white">
                                <span>Saldo</span>
                                <i class="fa fa-eye float-right" (click)="visualizarFicha=true"
                                  style="cursor: pointer;"></i>
                              </li>
                              <li class="list-group-item">Dotação <span class="float-right">{{saldoFixa?.dotacao |
                                  number:'1.2-2'}}</span>
                              </li>
                              <li class="list-group-item">Reservado <span class="float-right">{{saldoFixa?.reservado |
                                  number:'1.2-2'}}</span></li>
                              <li class="list-group-item font-weight-bold">
                                Saldo atual <span class="float-right font-weight-bold">{{saldoAtual() |
                                  number:'1.2-2'}}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-row">
                <div class="form-group col-sm-7">
                  <label for="setor">Setor</label>
                  <input readonly [value]="entidade.setor?.nome" type="text"
                    class="form-control-plaintext form-control text-center">
                </div>
                <div class="col-sm-5 form-group">
                  <label for="modalidade">Modalidade </label>
                  <input readonly [value]="entidade.modalidade?.nome" type="text"
                    class="form-control-plaintext form-control text-center">
                </div>
              </div>
              <div class="form-row mt-2">
                <div class="col-md-3 form-group">
                  <label for="prazo_entrega">Data Entrega</label>
                  <input readonly value="{{entidade.data_entrega | date:'dd/MM/yyyy':'GMT'}}" type="text"
                    class="form-control-plaintext form-control text-center">
                </div>
                <div class="col-md-3 form-group">
                  <label for="prazo_pagamento">Data Pagamento</label>
                  <input readonly value="{{entidade.data_pagamento | date:'dd/MM/yyyy':'GMT'}}" type="text"
                    class="form-control-plaintext form-control text-center">
                </div>
                <div class="col-md-6 form-group">
                  <label for="prazo">Prazo</label>
                  <input readonly [value]="entidade.prazo?.nome" type="text"
                    class="form-control-plaintext form-control text-center">
                </div>
              </div>
              <hr class="mt-3 mb-2" />
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-row">
                    <div class="col-sm-12">
                      <label for="ficha" style="display: block">Ficha de despesa</label>
                    </div>
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="form-group col-sm-3">
                          <input readonly [value]="entidade.ficha?.numero" type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                        <div class="form-group col-sm-9">
                          <input readonly
                            value="{{entidade.ficha?.despesa?.codigo}} -{{entidade.ficha?.despesa?.nome}} " type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-sm-12">
                      <label for="subelemento" style="display: block">Subelemento da despesa</label>
                    </div>
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="form-group col-sm-3">
                          <input readonly value="{{entidade.subelemento?.codigo | mascarar : '0.0.00.00.00.000'}}"
                            type="text" class="form-control-plaintext form-control text-center">
                        </div>
                        <div class="form-group col-sm-9">
                          <input readonly [value]="entidade.subelemento?.nome" type="text"
                            class="form-control-plaintext form-control text-center">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-row">
                <div class="form-group col-12">
                  <label for="obs">Justificativa</label>
                  <textarea readonly [value]="entidade.justificativa" class="form-control-plaintext form-control pl-2"
                    id="obs" rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <app-rcms-item [somenteVisualizar]="true" [(lista)]="itens" [(login)]="login"></app-rcms-item>
            </div>
            <div class="tab-pane fade" id="favorecido" role="tabpanel" aria-labelledby="favorecido-tab">
              <app-rcms-favorecido [somenteVisualizar]="true" [itens]="itens" [(lista)]="favorecidos" [(login)]="login">
              </app-rcms-favorecido>
            </div>
            <div class="tab-pane fade" id="cotacao" role="tabpanel" aria-labelledby="cotacao-tab">
              <app-rcms-cotacao [somenteVisualizar]="true" [(itens)]="itens" [favorecidos]="favorecidos"
                [(login)]="login"></app-rcms-cotacao>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<app-saldo-ficha-dlg [ficha]="this.entidade.ficha" [login]="login" [data]="this.entidade.data_rcms"
  [(visualizar)]="visualizarFicha">
</app-saldo-ficha-dlg>